// Module
var code = "<a href=\"#\"></a>";
// Exports
export default code;